module.exports = __webpack_public_path__ + "img/common-popup-hen.5d5595b0.png";